<h1 mat-dialog-title align="center">{{title}}</h1>
<div mat-dialog-content>
    <p class="mat-body-1">{{message}}</p>
</div>
<div mat-dialog-actions align="center">
    <form [formGroup]="approveRejectForm"> 
        <mat-form-field style="width: 280px;">
            <input type="text" matInput placeholder="Comment" formControlName="comment"> 
        </mat-form-field>
    </form>
    <div align="center">
        <button mat-raised-button (click)="onNoClick()" color="warn">Cancel</button>
        <button mat-raised-button color="primary" (click)="onSubmit()">Yes</button>
    </div>
</div>